import { Button, Card, Flex, Tag, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Content } from "antd/es/layout/layout";
import { getRandomColorTag } from "../../../Utils/generic-functions";
import LoaderContext from "../../../Context/LoaderContext/Index";
import JobCardLoader from "./JobCardLoader";
import { JobDescription } from "../../../Entities/job-description.entity";

interface JobCardProps {
  jobDescription: JobDescription;
  handleViewDetails: () => void;
  handleApply: (id: string) => void;
  appliedJobIds: string[];
}
const JobCard: React.FC<JobCardProps> = ({
  appliedJobIds,
  handleApply,
  handleViewDetails,
  jobDescription,
}) => {
  const { title, description, position }: any = jobDescription;
  const { isLoading } = useContext(LoaderContext);

  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const isApplied = appliedJobIds.includes(jobDescription._id);

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const truncatedDescription =
    description?.length > 200 ? description.slice(0, 200) + "..." : description;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 769);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOnApplyButtonClick = (
    e: React.MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    e.stopPropagation();
    handleApply(id);
  };

  return (
    <Card className="card_container" hoverable onClick={handleViewDetails}>
      {jobDescription ? (
        <>
          <Flex align="center" justify="space-between">
            <Tag color={getRandomColorTag()}>{position}</Tag>
            <Flex
              align="center"
              justify="space-between"
              className="card_button_section"
              style={{
                display: isMobile ? "none" : "flex",
              }}
            >
              <Button onClick={handleViewDetails} loading={isLoading}>
                {isApplied ? "View Application" : "View Details"}
              </Button>
              {!isApplied && (
                <Button
                  onClick={(e: any) =>
                    handleOnApplyButtonClick(e, jobDescription._id)
                  }
                  style={{ marginLeft: "16px" }}
                  type="primary"
                  loading={isLoading}
                >
                  Apply Now
                </Button>
              )}
            </Flex>
          </Flex>
          <Content>
            <Typography.Title
              level={4}
              className="card_title"
              style={{ marginTop: 8 }}
            >
              {title}
            </Typography.Title>
            
            <Typography.Paragraph
              className="card_description"
              style={{ marginBottom: 8 }}
            >
              {isMobile && !isExpanded ? truncatedDescription : description}
              {isMobile && description?.length > 20 && (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  onClick={toggleDescription}
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {isExpanded ? " Show less" : " View more"}
                </a>
              )}
            </Typography.Paragraph>

            <Flex
              style={{
                display: isMobile ? "flex" : "none",
              }}
            >
              {!isApplied && (
                <Button
                  onClick={(e: any) =>
                    handleOnApplyButtonClick(e, jobDescription._id)
                  }
                  style={{
                    width: "100%",
                  }}
                  type="primary"
                  loading={isLoading}
                >
                  Apply Now
                </Button>
              )}
            </Flex>

          </Content>
        </>
      ) : (
        <JobCardLoader />
      )}
    </Card>
  );
};

export default JobCard;
